import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import { multiplierData } from './MultiplierData';
import './NetPriceReport.css';
import useAuth from '../../hooks/useAuth';
import Loader from '../../components/Loader/Loader';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import ShareModal from '../../components/Modals/ShareModal';
import printIcon from '../../assets/images/print-img.png';
import shareIcon from '../../assets/images/share-img.png';
import pdfIcon from '../../assets/images/pdf-img.png';
import xlsIcon from '../../assets/images/xls-img.png';
import NetPriceReportServices from '../../services/NetPriceReportServices';
import UserServices from '../../services/UserServices';

const netPriceReportServices = new NetPriceReportServices();
const userServices = new UserServices();

const NetPriceReport = () => {
	const { user , updateCustomers } = useAuth();
	const [showSpinner, setShowSpinner] = useState(0);
	const [showLoader, setShowLoader] = useState(1);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [customers, setCustomers] = useState([]);
	const [multipliers, setMultipliers] = useState([]);
	const [showShareModal, setShowShareModal] = useState(false);
	const [customerLoaded, setCustomerLoaded] = useState(false);

	useEffect(() => {
		seo({
			title: SITE_TITLE + ' || Net Price Report',
			metaDescription: '',
		});
		if(user && !customerLoaded) {
			setCustomerLoaded(true);
			userServices.getCustomerdata({portal_user_id: user.id, portal_user_name: user.name, customer_from: 'fishbowl'}).then(response => {
				const data = response.data;
				if(data.status === 'success') {
					const mappedCustomers = data.result.map(c => ({
						value: c.id,
						label: c.name,
					}));
					setCustomers(mappedCustomers);
					if (mappedCustomers.length > 0) {
						updateCustomers(mappedCustomers);
					}
				}
				setShowLoader(0);
			})
		}
	}, [user]);

	useEffect(() => {
		if(selectedCustomer) {
			setShowSpinner(1);
			setMultipliers([]);
			netPriceReportServices.getCustomerMultipliers({company_name:selectedCustomer.label}).then(response => {
				setShowSpinner(0);
				const data = response.data;
				if(data.status === 'success') {
					setMultipliers(data.result);
				}
			});
		}
	},[selectedCustomer]);

	const getMultiplier = (multiplier) => {
		let multiplier_value = 'Not Set';
	    if (multiplier) {
	      const found = multipliers.find((data) => data.multiplier_group === multiplier);
	      if (found) {
	        multiplier_value = found.customer_multiplier;
	      }
	    }
	    return multiplier_value;
	}

	const renderMultiplierTable = () => {
		return (
			<React.Fragment>
		        {multiplierData.length > 1 ? (
		          multiplierData.map((value, index) => {
		            const pageKeys = Object.keys(value.page).sort((a, b) => {
		              const getStartPage = (key) => parseInt(key.split('-')[0], 10);
		              return getStartPage(a) - getStartPage(b);
		            });

		            return pageKeys.map((value2, index2) => (
		              <tr key={`${index}-${index2}`}>
		                {index2 === 0 && (
		                  <>
		                    <td rowSpan={pageKeys.length}>{value.multiplier_code}</td>
		                    <td rowSpan={pageKeys.length}>{getMultiplier(value.multiplier_code)}</td>
		                  </>
		                )}
		                <td>{value2}</td>
		                <td>{value.page[value2]}</td>
		              </tr>
		            ));
		          })
		        ) : (
		          <tr>
		            <td colSpan="4">No data found.</td>
		          </tr>
		        )}
	      	</React.Fragment>
	    );

	}

	const renderNetPricingData = () => {
		return(
			<React.Fragment>
				{selectedCustomer && 
					(
						<div className="row">
		        			<div className="col-md-9">
		        				<div id="print-section">
		        					<div className="col-md-12 mt-3">
		        						<h4 className="dark-color1 text-center">Net Pricing Report Prepared for</h4>
		        						<h3 className="dark-color1 text-center">{selectedCustomer.label}</h3>
		        						<div className="table-responsive">
		        							<table className="table table-bordered text-center" id="techtop-net-pricing-report-table">
		        								<thead>
		        									<tr>
		        										<th>Multiplier Code</th>
		        										<th>Discount Multiplier</th>
		        										<th>Pages</th>
		        										<th>Motor Line Descriptions</th>
		        									</tr>
		        								</thead>
		        								<tbody>
					                              {showSpinner ? (
					                                <tr>
					                                  <td colSpan="4">
					                                    <GearSpinner />
					                                  </td>
					                                </tr>
					                              ) : (renderMultiplierTable()
					                              )}
		        								</tbody>
		        							</table>
		        						</div>
		        					</div>
		        				</div>
		        			</div>
		        			<div className="col-md-3 mt-3">
		        				<ul className="net-pricing-report-list no-print">
		        					<li>
		        						<button type="button" onClick={printReport} className="btn-link-style">
										  <img src={printIcon} alt="Print" /> Print
										</button>
		        						{/*<a href='javascript:void(0)' onClick={printReport}>
		        							<img src={printIcon} alt="Print" /> Print
		        						</a>*/}
		        					</li>
		        					<li>
		        						<button className="btn-link-style" onClick={(e) => {
		        							e.preventDefault(); // prevent page reload on anchor click
				                            setShowShareModal((prev) => !prev);
				                          }}
				                      	>
				                      		<img src={shareIcon} alt="Share" /> Share
				                      	</button>
				                    </li>
				                    <li>
				                    	<button className="btn-link-style" onClick={downloadPDF}><img src={pdfIcon} alt="Export PDF" />Export PDF</button>
				                    </li>
				                    <li>
				                    	<button className="btn-link-style" onClick={downloadExcel}><img src={xlsIcon} alt="Export Excel" />Export Excel</button>
				                    </li>
				                </ul>
				            </div>
		        		</div>
		        	)
				}
			</React.Fragment>
		)
	}

	const renderDefaultData = () => {
		if (!selectedCustomer) {
			return (
			<div className="text-center my-5 fade-in">
				<div className="p-5 rounded-3 shadow-sm bg-light border d-inline-block">
				
				<h3 className="fw-bold text-dark">No Customer Selected</h3>
				<p className="text-muted mb-0">
					Please <span className="fw-semibold">select a customer</span> from the dropdown above to view their Net Price Report.
				</p>
				</div>
			</div>
			);
		}
	};


	const printReport = async () => {
		const originalTitle = document.title;
		const formattedDate = moment().format('MM/DD/YYYY HH:mm');
		document.title = `${selectedCustomer.label}-netprice-report-${formattedDate}`;
		window.print();
		document.title = originalTitle;
	}

	const downloadPDF = async () => {
		setShowLoader(1);
	    try {
	    	netPriceReportServices.exportNetpricePdf(selectedCustomer.label).then((response) => {
	    		const blob = response.data; // Already a Blob object
	    		const url = window.URL.createObjectURL(blob);
	    		const link = document.createElement('a');
	    		const formattedDate = moment().format('MM-DD-YYYY_HH-mm'); // Safe for filenames
	    		const title = `${selectedCustomer.label}-netprice-report-${formattedDate}`;
	    		link.href = url;
	    		link.download = `${title}.pdf`;
	    		document.body.appendChild(link);
	    		link.click();
	    		document.body.removeChild(link);
	    		window.URL.revokeObjectURL(url);
	    		setShowLoader(0);
	    	}).catch((error) => {
	    		console.error('Error downloading file:', error);
	    		setShowLoader(0);
	    	});
	    } catch (error) {
	    	console.error('Error downloading datasheet:', error);
	    	setShowLoader(0);
	    }

	}

	const downloadExcel = async () => {
		setShowLoader(1);
	    try {
	    	netPriceReportServices.exportNetpriceExcel(selectedCustomer.label).then((response) => {
	    		const blob = response.data;
		        const url = window.URL.createObjectURL(blob);
		        const link = document.createElement('a');
		        const formattedDate = moment().format('MM/DD/YYYY HH:mm');
		        const title = `${selectedCustomer.label}-netprice-report-${formattedDate}`;
		        link.href = url;
		        link.download = `${title}.xlsx`;
		        link.click();
		        window.URL.revokeObjectURL(url);
		        setShowLoader(0);

	    	});
	    } catch (error) {
	    	console.error('Error downloading datasheet:', error);
	        setShowLoader(0);
	    }
	}

	return (
		<React.Fragment>
			<main className="techtop-middle-div">
				<section className="techtop-quality-control-section pt-2 pb-3">
					<div className="container">
						{/* Page Title */}
						<div className="row">
							<div className="col-md-12">
								<div className="techtop-default-title2">
									<div className="row">
										<div className="col-md-6">
											<h1 className="m-0 dark-color1">Net Pricing Report</h1>
										</div>
										<div className="col-md-6 text-end">
											<h1 className="m-0 dark-color1">{user?.name}</h1>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						{/* Customer Select */}
						<div className="row">
							<div className="col-md-12">
								<div className="techtop-default-title2 py-2 text-center m-0">
									<form>
										<div className="row">
											<div className="col-md-4 align-self-center">
												<h5 className="m-0 text-end">Customer Name</h5>
											</div>
											<div className="col-md-8">
												<Select
													classNamePrefix="react-select"
													placeholder="Search by Customer..."
													options={customers}
													value={selectedCustomer}
													isClearable
													onChange={(selected) => setSelectedCustomer(selected)}
												/>
											</div>

										</div>
									</form>
								</div>
							</div>
						</div>
						
						{/* Customer net pricing */}
						<div className="row">
							<section className="techtop-net-pricing-report-section pb-5">
						        <div className="container">
						            <div className="row">
						            	<div className="col-md-12">
						            		{!showLoader && renderDefaultData()}
						            		{renderNetPricingData()}
						            	</div>
									</div>
						        </div>
						    </section>
						</div>
					</div>
				</section>
				<Loader isLoading={showLoader} message="Processing..."/>
				<ShareModal isShow={showShareModal} onClose={() => setShowShareModal(false)} customer={selectedCustomer}/>
			</main>
		</React.Fragment>
	);
};

export default NetPriceReport;